import { MediaAlbumListView } from '@euler/app/flows/common/components/MediaAlbumListView';
import { useServiceRecordMediaAlbums } from '@euler/app/flows/record/functions/useServiceRecordMediaAlbums';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { ServiceRecordNavParams } from '@euler/app/flows/record/ServiceRecordFlow';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { isAlbumByYearMonth, MediaAlbum } from '@euler/model';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';

export const ServiceRecordMediaAlbumsPage = wrapNavigatorScreen(
  () => {
    const {
      serviceRecord: { _id, licensePlateNo, vin },
    } = useServiceRecordContext();

    const {
      state: albums,
      loading,
      error,
      refreshing,
      invalidate,
    } = useServiceRecordMediaAlbums();

    const navigation =
      useNavigation<StackNavigationProp<ServiceRecordNavParams>>();

    const onPress = useCallback(
      (album: MediaAlbum) => {
        navigation.navigate('medias', {
          origin: `service-records/${_id}`,
          licensePlateNo,
          vin,
          target: isAlbumByYearMonth(album)
            ? {
                type: 'year-month',
                year: album.value.year,
                month: album.value.month,
              }
            : {
                type: 'mileage',
                mileage: album.value,
              },
        });
      },
      [licensePlateNo, navigation, vin, _id],
    );

    return (
      <MediaAlbumListView
        albums={albums ?? []}
        loading={loading}
        refreshing={refreshing}
        error={error}
        onRefresh={invalidate}
        onAlbumPress={onPress}
      />
    );
  },
  {
    title: '媒体图库',
  },
);
